import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ModalImage from 'react-modal-image';
import { SimpleShareButtons } from 'react-simple-share';
import { AppContext } from '../../core/Contexts/AppContext';
import { getDangerProductDetails } from '../../core/services';

const DetailDangerProduct = () => {
  const params = useParams();

  const [product, setProduct] = useState();
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  useEffect(() => {
    setTitle('საფრთხის შემცველი პროდუქტები');
    // setImage('./../images/hero-images/danger-products.png');

    setHeaderType(1);
  }, []);

  useEffect(() => {
    void getDangerProductDetails(params.id).then((result) => {
      setProduct(result);
    });
  }, [params.id]);

  if (!product) {
    return <div>No product details available</div>;
  }

  return (
    <section className='bg__gray-2'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-5'>
            <div className='project-info-box mt-0'>
              <h6>
                <b>{product.product_title}</b>
              </h6>
            </div>

            <div className='project-info-box'>
              <p>
                <b>შეუსაბამობისა და საფრთხის მოკლე აღწერა:</b>
                <br />
                {product.danger_description}
              </p>
              <p>
                <b>გამოქვეყნებულია:</b> {product.event_held_date}
              </p>
              <p>
                <b>სავაჭრო ნიშანი:</b> {product.trademark}
              </p>
              <p>
                <b>ქვეყანა:</b> {product.country_name}
              </p>
              <p className='mb-0'>
                <b>კატეგორია:</b> {product.category_name}
              </p>
            </div>

            <div className='project-info-box mt-0 mb-0'>
              <div className='shareProduct'>
                <b>გააზიარე: </b>
                <SimpleShareButtons
                  url={window.location.href}
                  whitelist={['Facebook', 'Twitter', 'LinkedIn']}
                  size='40px'
                />
              </div>
            </div>
          </div>

          <div className='col-md-7'>
            <ModalImage
              className='rounded modal-image w-100 mb-3 mt-m20 '
              alt={product.product_title}
              small={`${process.env.REACT_APP_FORMS_URl}/uploads/${product.doc}`}
              large={`${process.env.REACT_APP_FORMS_URl}/uploads/${product.doc}`}
              hideDownload={true}
              hideZoom={true}
            />
            <div className='project-info-box'>
              <p>
                <b>გატარებული ღონისძიება:</b> {product.held_text}
              </p>
              <p>
                <b>ძალაში სესვლის თარიღი:</b> {product.event_held_date}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DetailDangerProduct;
